import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getEmails } from "../../services/clients";
import EmailsTable from "../../components/Tables/EmailsTable";

export const Emails = () => {
  const { selectedClient } = useContext(AppContext);
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        setEmails(
          await getEmails(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchEmails();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <EmailsTable emails={emails} />
    </div>
  );
};

export default Emails;
